import React, {useMemo, useEffect, useState} from "react";
import objectPath from "object-path";
import {useHtmlClassService} from "../../layout";
import {MainDashboard} from "./MainDashboard";
import { useLocation} from "react-router-dom"

export function Dashboard(params) {

    const location = useLocation();
    const [hash, setHash] = useState(null);

    useEffect(() => {
        if (location.props) {
            if (location.props.hash !== hash) {
                setHash(location.props.hash);
            }
        }
    }, [location, hash]);


    const uiService = useHtmlClassService();
    const layoutProps = useMemo(() => {
        return {
            demo: objectPath.get(
                uiService.config,
                "demo"
            )};
    }, [uiService]);

    return <>
        <MainDashboard />
    </>;
}
